import { Category } from '@/app/cv/constants/products/category';
import type { GenerateBaseMetadataProps } from '@/app/utils/metadata';

export const META_DATA: GenerateBaseMetadataProps = {
  title: 'การบำรุงรักษาตามระยะ',
  description:
    'ตรวจสอบรายการบำรุงรักษาตามระยะและค่าใช้จ่ายเบื้องต้นก่อนนำรถเข้าเช็กระยะ',
  url: '/service/maintenance-list',
  img: 'https://assets.isuzu-tis.com/og_service_f66703b6eb.jpg',
};

export const PLACEHOLDER_MOBLE =
  'https://assets.isuzu-tis.com/bg_cc26360ea3.jpg';
export const PLACEHOLDER_DESKTOP =
  'https://assets.isuzu-tis.com/bg_cc26360ea3.jpg';
export const PLACEHOLDER_TEXT = 'กรุณาเลือก<br>รุ่นรถบรรทุก';

export const SELECTS_DATA: {
  name: string;
  placeholder: string;
}[] = [
  {
    name: 'category',
    placeholder: 'เลือกประเภทรถ',
  },
  {
    name: 'model',
    placeholder: 'เลือกรุ่นรถ',
  },
  {
    name: 'year',
    placeholder: 'เลือกรุ่นปี',
  },
  {
    name: 'schedule',
    placeholder: 'เลือกระยะเวลาหรือระยะทาง',
  },
];

export const CATEGORY_ORDER = {
  'รถบรรทุก 4 ล้อ': 0,
  'รถ 6 ล้อขนาดกลาง': 1,
  'รถ 6 ล้อ ขนาดกลาง': 1,
  'รถ 6 ล้อ ขนาดใหญ่': 2,
  'รถ 10 ล้อ เพลาเดียว': 3,
  'รถ 10 ล้อ 2 เพลา': 4,
  'รถ 12 ล้อ': 5,
  หัวลาก: 6,
  'รถผสมปูน (Mixer)': 7,
  'มินิบัส แชสชีส์': 8,
  'มินิบัส แชสซีส์': 8,
};
export const CATEGORY_CUSTOM_LABEL = {
  'รถ 6 ล้อขนาดกลาง': 'รถ 6 ล้อ ขนาดกลาง',
  'มินิบัส แชสชีส์': 'มินิบัส แชสซีส์',
};
export const CATEGORY_TO_NAME = {
  'รถบรรทุก 4 ล้อ': Category.TRUCK_4_WHEELS,
  'รถ 6 ล้อ ขนาดกลาง': Category.TRUCK_6_WHEELS_MIDDLE,
  'รถ 6 ล้อ ขนาดใหญ่': Category.TRUCK_6_WHEELS_LARGE,
  'รถ 10 ล้อ เพลาเดียว': Category.TRUCK_10_WHEELS_1_AXLE,
  'รถ 10 ล้อ 2 เพลา': Category.TRUCK_10_WHEELS_2_AXLE,
  'รถ 12 ล้อ': Category.TRUCK_12_WHEELS,
  หัวลาก: Category.TRUCK_TRACTOR,
  'รถผสมปูน (Mixer)': Category.TRUCK_MIXER,
  'มินิบัส แชสซีส์': Category.TRUCK_MINIBUS_CHASSIS,

  // Handle Contentstack typo case in some possible cases
  'รถ 6 ล้อขนาดกลาง': Category.TRUCK_6_WHEELS_MIDDLE,
  'มินิบัส แชสชีส์': Category.TRUCK_MINIBUS_CHASSIS, // ช ช้่าง and ซ โซ่ typo
};

export const OLD_CV_MODEL_QUERY = {
  'nmr-130-5-speed': 'nmr1305',
  'nmr-130-6-speed': 'nmr1306',
  'fxz-mixer-320': 'fxzmixer',
  'frr-mixer-190': 'frrmixer',
  'gxz-the-rock': 'gxztherockgxziesc',
  'gxz-iesc': 'gxztherockgxziesc',
};

export const DEFAULT_VEHICLE_IMAGE =
  'https://assets.isuzu-tis.com/isuzu_truck_default_b139be5b7d.png?tr=w-320,f-auto,q-85';

export const MODEL_IMAGE_MAP = {
  'truck-mixer_fxzmixereuro5':
    'https://assets.isuzu-tis.com/euro_5_fxz_mixer_428e84a5af.png',
  'truck-mixer_frrmixereuro5':
    'https://assets.isuzu-tis.com/euro_5_frr_mixer_78f05f253b.png',
  'truck-mixer_nmrmixereuro5':
    'https://assets.isuzu-tis.com/euro_5_nmr_mixer_8c6a737d46.png',
  'truck-tractor_ftreuro5':
    'https://assets.isuzu-tis.com/euro_5_ftr_tractor_580906e78d.png',
  'truck-tractor_gxzeuro5':
    'https://assets.isuzu-tis.com/euro_5_gxz_098b6e8895.png',
  'truck-tractor_gxzabseuro5':
    'https://assets.isuzu-tis.com/euro_5_gxz_098b6e8895.png',
  'truck-12-wheels_fyheuro5':
    'https://assets.isuzu-tis.com/euro_5_fyh_962deb9dc8.png',
  'truck-10-wheels-2-axle_fvz-seuro5':
    'https://assets.isuzu-tis.com/euro_5_fvz_s_af4999fd71.png',
  'truck-10-wheels-2-axle_fvzeuro5':
    'https://assets.isuzu-tis.com/euro_5_fvz_733a4ae0de.png',
  'truck-10-wheels-2-axle_fxzeuro5':
    'https://assets.isuzu-tis.com/euro_5_fxz_8f2fe5cfe1.png',
  'truck-10-wheels-1-axle_fvmfvmiesceuro5':
    'https://assets.isuzu-tis.com/euro_5_fvm_iesc_0ff34f0d7c.png',
  'truck-10-wheels-1-axle_fvmiesceuro5':
    'https://assets.isuzu-tis.com/euro_5_fvm_iesc_0ff34f0d7c.png',
  'truck-10-wheels-1-axle_fvm-seuro5':
    'https://assets.isuzu-tis.com/euro_5_fvm_s_3b031a0f03.png',
  'truck-10-wheels-1-axle_fvmeuro5':
    'https://assets.isuzu-tis.com/euro_5_fvm_31e19c6110.png',
  'truck-6-wheels-large_ftrsmoothereuro5':
    'https://assets.isuzu-tis.com/euro_5_ftr_fa557df30a.png',
  'truck-6-wheels-large_ftreuro5':
    'https://assets.isuzu-tis.com/euro_5_ftr_fa557df30a.png',
  'truck-6-wheels-middle_frr-seuro5':
    'https://assets.isuzu-tis.com/euro_5_frr_s_af6381b6db.png',
  'truck-6-wheels-middle_frreuro5':
    'https://assets.isuzu-tis.com/euro_5_frr_1e3414bb10.png',
  'truck-6-wheels-middle_nqreuro5':
    'https://assets.isuzu-tis.com/euro_5_nqr_fc69cf3df5.png',
  'truck-6-wheels-middle_nprsmoothereuro5':
    'https://assets.isuzu-tis.com/euro_5_npr_a66cc673cc.png',
  'truck-6-wheels-middle_npreuro5':
    'https://assets.isuzu-tis.com/euro_5_npr_a66cc673cc.png',
  'truck-6-wheels-middle_nmr6euro5':
    'https://assets.isuzu-tis.com/euro_5_nmr_f47ca3df52.png',
  'truck-6-wheels-middle_nmr5euro5':
    'https://assets.isuzu-tis.com/euro_5_nmr_f47ca3df52.png',
  'truck-4-wheels_nlrsmoothereuro5':
    'https://assets.isuzu-tis.com/euro_5_nlr_0de3e15077.png',
  'truck-4-wheels_nlreuro5':
    'https://assets.isuzu-tis.com/euro_5_nlr_0de3e15077.png',
  'truck-mixer_fxzmixer':
    'https://assets.isuzu-tis.com/fxz_320_2022_mixer_bf01db9cb6.png',
  'truck-mixer_frrmixer':
    'https://assets.isuzu-tis.com/frr_mixer_190_center_3508483591.png',
  'truck-mixer_nmrmixer':
    'https://assets.isuzu-tis.com/elf_mixer_097b0757a1.png',
  'truck-minibus-chassis_npr150minibuschassis':
    'https://assets.isuzu-tis.com/npr_mini_bus_chassis_617fc72c6a.png',
  'truck-minibus-chassis_npr150minibuschassiseuro5':
    'https://assets.isuzu-tis.com/npr_mini_bus_chassis_617fc72c6a.png',
  'truck-tractor_gxz360':
    'https://assets.isuzu-tis.com/euro_3_gxz_13399f55e8.png',
  'truck-tractor_gxztherockgxziesc':
    'https://assets.isuzu-tis.com/euro_3_gxz_13399f55e8.png',
  'truck-tractor_gxz345':
    'https://assets.isuzu-tis.com/euro_3_gxz_the_rock_91f352628f.png',
  'truck-12-wheels_fyh360': 'https://assets.isuzu-tis.com/fyh_69694d2ee3.png',
  'truck-10-wheels-2-axle_fvz300':
    'https://assets.isuzu-tis.com/fvz_300_240_center_591f799ecf.png',
  'truck-10-wheels-2-axle_fvz240':
    'https://assets.isuzu-tis.com/fvz_300_240_center_29a5c30dea.png',
  'truck-10-wheels-2-axle_fxz360':
    'https://assets.isuzu-tis.com/fxz_f7830c02e8.png',
  'truck-10-wheels-2-axle_fxztherock':
    'https://assets.isuzu-tis.com/euro_3_fxz_the_rock_fd496e5285.png',
  'truck-10-wheels-2-axle_fxz345':
    'https://assets.isuzu-tis.com/fxz_f7830c02e8.png',
  'truck-10-wheels-1-axle_fvm300':
    'https://assets.isuzu-tis.com/fvm_300_240_center_5534c68a6e.png',
  'truck-10-wheels-1-axle_fvm240':
    'https://assets.isuzu-tis.com/fvm_300_240_center_5534c68a6e.png',
  'truck-6-wheels-large_ftr240smoother':
    'https://assets.isuzu-tis.com/ftr_240_center_70d8805c13.png',
  'truck-6-wheels-large_ftr240':
    'https://assets.isuzu-tis.com/ftr_240_center_70d8805c13.png',
  'truck-6-wheels-middle_frr210':
    'https://assets.isuzu-tis.com/frr_210_190_center_6cf7158202.png',
  'truck-6-wheels-middle_frr190':
    'https://assets.isuzu-tis.com/frr_210_190_center_6cf7158202.png',
  'truck-6-wheels-middle_nqr175':
    'https://assets.isuzu-tis.com/nqr_175_revise_cf7f0f6bc4.png',
  'truck-6-wheels-middle_npr150smoother':
    'https://assets.isuzu-tis.com/npr_150_revise_d08f88442c.png',
  'truck-6-wheels-middle_npr150':
    'https://assets.isuzu-tis.com/npr_150_revise_d08f88442c.png',
  'truck-6-wheels-middle_nmr1306':
    'https://assets.isuzu-tis.com/nmr_130_revise_1bba5e474b.png',
  'truck-6-wheels-middle_nmr1305':
    'https://assets.isuzu-tis.com/nmr_130_revise_1bba5e474b.png',
  'truck-4-wheels_nlr130smoother':
    'https://assets.isuzu-tis.com/nlr_130_97abf87c33.png',
  'truck-4-wheels_nlr130':
    'https://assets.isuzu-tis.com/nlr_130_97abf87c33.png',
  'truck-4-wheels_nlrlite':
    'https://assets.isuzu-tis.com/euro_3_nlr_lite_c79c244dce.png',
};

/**
 * Internal note for maintaining previous URL query
 */
// const OLD_CV_MODELS = [
//   'nlr-lite',
//   'nlr-130',
//   'nlr-130-smoother',
//   'frr-190',
//   'frr-210',
//   'nmr-130-5-speed',
//   'nmr-130-6-speed',
//   'npr-150',
//   'npr-150-smoother',
//   'nqr-175',
//   'ftr-240',
//   'ftr-240-smoother',
//   'fvm-240',
//   'fvm-300',
//   'fxz-345',
//   'fxz-the-rock',
//   'fxz-360',
//   'fvz-240',
//   'fvz-300',
//   'fyh-360',
//   'gxz-345',
//   'gxz-the-rock',
//   'gxz-iesc',
//   'gxz-360',
//   'fxz-mixer-320',
//   'frr-mixer-190',
//   'nmr-mixer-130',
//   'npr-150-mini-bus-chassis',
// ];
